export const importPage = require('./' + process.env.NODE_ENV).default;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/import/index.ts